import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import BtnListTypeSetting from 'components/property-settings/btn-list-type-setting/btn-list-type-setting';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type ContactTypeProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    contactType: string;
    options?: string[];
    isRequired?: boolean;
};

const ContactType: FC<ContactTypeProps> = ({ handleSettings, contactType, options, isRequired }: ContactTypeProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('CONTACT_TYPE')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <BtnListTypeSetting
                setting={options ? options : CONSTANTS.CONTACT_TYPE}
                propertyName="contactType"
                settingValue={contactType}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default ContactType;
